import { NgModule } from '@angular/core';
import { SharedModule } from './shared.module';
import {
  ActiveAttributesComponent,
  DynamicLegAttributeComponent,
  ExtraResultsDisplayComponent,
  LegComponent,
  PricingResultsDisplayComponent,
  MarketDataDisplayComponent,
  ScheduleComponent,
  CopyLegModalComponent,
  SolverComponent,
  SaveTradeComponent,
  LegDescriptionComponent,
  DcdResultsDisplayComponent,
  OptionsPortfolioComponent,
  OptionsPortfolioSpotsComponent,
  BasketComponent
} from '../widgets';
import {
  ActiveAttributesPipe,
  ExtraAttributesFilterPipe,
  ScheduleFieldDisabledPipe,
  ScheduleFormatPipe
} from './pipes';
import { QuoteScheduleComponent } from '@approot/widgets/strategy-detail/modals/quote-schedule/quote-schedule.component';
import { MovementIndicatorComponent } from '@approot/widgets/strategy-detail/modals/quote-schedule/movement-indicator.component';

@NgModule({
  declarations: [
    ActiveAttributesComponent,
    DynamicLegAttributeComponent,
    ExtraResultsDisplayComponent,
    LegComponent,
    MarketDataDisplayComponent,
    PricingResultsDisplayComponent,
    ActiveAttributesPipe,
    CopyLegModalComponent,
    ScheduleComponent,
    SolverComponent,
    SaveTradeComponent,
    LegDescriptionComponent,
    ScheduleFormatPipe,
    DcdResultsDisplayComponent,
    ScheduleFieldDisabledPipe,
    ExtraAttributesFilterPipe,
    OptionsPortfolioComponent,
    OptionsPortfolioSpotsComponent,
    BasketComponent,
    QuoteScheduleComponent,
    MovementIndicatorComponent
  ],
  imports: [SharedModule],
  exports: [
    ActiveAttributesComponent,
    ActiveAttributesPipe,
    DynamicLegAttributeComponent,
    ExtraResultsDisplayComponent,
    LegComponent,
    MarketDataDisplayComponent,
    PricingResultsDisplayComponent,
    CopyLegModalComponent,
    ScheduleComponent,
    SolverComponent,
    SaveTradeComponent,
    LegDescriptionComponent,
    DcdResultsDisplayComponent,
    OptionsPortfolioComponent,
    OptionsPortfolioSpotsComponent,
    BasketComponent,
    QuoteScheduleComponent
  ]
})
export class SharedLegModule {}
